module.exports = __webpack_public_path__ + "img/join-08.8fcda3e0.jpg";